import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { Location } from "../interfaces/Location";

interface Props {
  onAuthError?: () => void;
}

export default class LocationAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/Locations/`;

  getLocationById = (locationId: number): Promise<Location> => {
    const apiAddress = `${LocationAPIs.BASE_URL}${locationId}`;
    return this.apiResponseHandler.get(apiAddress);
  };
}
